import { useTranslations } from "use-intl";
import ReferencePicker from "./reference-picker";

export interface ToolsAllowedPickerProps {
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
  nodeType?: string;
  fieldKey?: string;
}

export function ToolsAllowedPicker({
  value,
  onChange,
  disabled,
  nodeType,
  fieldKey = "tools",
}: ToolsAllowedPickerProps) {
  const t = useTranslations("workflows");

  return (
    <ReferencePicker
      kind="mcp_tool"
      action="use"
      nodeType={nodeType}
      fieldKey={fieldKey}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={t("drawer.reference.search_mcp_tool")}
    />
  );
}

export default ToolsAllowedPicker;
